import { listen, qs, qsa, remove, toggle } from "@fluorescent/dom";

import { on } from "@/neon/events";

import MegaNavLegacy from "@/lib/mega-nav-legacy";
import MegaNav from "@/lib/mega-nav";

export default function Navigation(node) {
  if (!node) return;

  const parents = qsa("[data-parent]", node);
  const megaParents = qsa("[data-mega]", node);

  if (!parents && !megaParents) return;

  let current = null;

  const events = [
    listen(document, "click", e => handleBodyClick(e)),
    listen([...parents, ...megaParents], "mouseup", e => e.preventDefault()),
    listen(parents, "click", e => e.preventDefault()),

    // Close on escape
    listen(node, "keydown", event => {
      const { keyCode } = event;
      if (keyCode === 27) closeAll(event);
    }),

    listen(parents, "click", e => {
      e.preventDefault();

      [...e.currentTarget.parentNode.parentNode.children]
        .filter(el => !el.contains(e.currentTarget))
        .forEach(el => remove(qsa("[data-submenu]", el), "active"));

      toggleMenu(e.currentTarget.parentNode, e.currentTarget);
    }),

    listen(megaParents, "click", e => {
      e.preventDefault();
      const menuLeftPosition = e.currentTarget?.getBoundingClientRect()?.left;

      const megaNavLegacyEl = qs(
        "[data-mega-nav-legacy]",
        e.currentTarget.parentNode
      );
      const megaNavEl = qs("[data-mega-nav]", e.currentTarget.parentNode);

      if (megaNavLegacyEl) {
        const megaNavLegacy = MegaNavLegacy(megaNavLegacyEl);
        megaNavLegacy.open({ leftPosition: menuLeftPosition });
      } else if (megaNavEl) {
        const megaNav = MegaNav(megaNavEl);
        megaNav.open();
      }
    }),

    listen(qsa(".header__links-list > li > a", node), "focus", closeAll),

    // Close everything when focus leaves the main menu
    listen(qsa("[data-link]", node), "focusout", e => {
      if (e.relatedTarget && !e.relatedTarget.hasAttribute("data-link")) {
        closeAll();
      }
    }),

    on("megaNavLegacy:open", (_, { id }) => {
      current = MegaNavLegacy(qs(`[data-id="${id}"]`, node));
      current.open();
    }),

    on("megaNav:open", (_, { id }) => {
      current = MegaNav(qs(`[data-id="${id}"]`, node));
      current.open();
    }),

    on(["megaNavLegacy:close", "megaNav:close"], () => {
      current && current.close();
    }),
  ];

  function handleBodyClick(e) {
    if (e?.target && !e.target.closest("[data-submenu-parent]")) {
      closeAll();
    }
  }

  function toggleMenu(listElement, linkElement) {
    const header = qs("[data-section-type='header']");
    const menu = qs("[data-submenu]", listElement);
    const willShow = !menu.offsetWidth > 0 && !menu.offsetHeight > 0;

    if (willShow && linkElement.dataset.topLevelParent) {
      const headerLeftPosition = header?.getBoundingClientRect()?.left;
      const menuLeftPosition = listElement?.getBoundingClientRect()?.left;
      menu.style.left = `${menuLeftPosition - headerLeftPosition}px`;
    }

    toggle(menu, "active", willShow);
  }

  function closeAll(e) {
    const focusedElement = qs(":focus", node);

    const potentialOpenElementParent = focusedElement?.closest(
      "[data-submenu-parent]"
    );

    if (
      potentialOpenElementParent &&
      focusedElement.parentNode !== potentialOpenElementParent
    ) {
      setTimeout(function () {
        qs("a", potentialOpenElementParent).focus();
      }, 100);
    }

    remove(qsa("[data-submenu]", node), "active");
  }

  function destroy() {
    events.forEach(evt => evt());
  }

  return { destroy };
}
